import LocationInput from './LocationInput.jsx';

export default LocationInput;



// WEBPACK FOOTER //
// ./src/components/Header/MoveableDiv/SearchBar/SearchBarLarge/LocationInput/index.js